const STORAGE_KEY = "yuma_grouped_variant_parents";
export const GROUPED_VARIANT_PARENTS_HEADER = "X-Yuma-Grouped-Variant-Parents";

type GroupedVariantParentMap = Record<string, number>;

function readMap(): GroupedVariantParentMap {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const value = JSON.parse(
      window.localStorage.getItem(STORAGE_KEY) ?? "{}",
    ) as unknown;

    if (!value || typeof value !== "object" || Array.isArray(value)) {
      return {};
    }

    return Object.fromEntries(
      Object.entries(value)
        .map(([childId, parentId]) => [childId, Number(parentId)] as const)
        .filter(
          ([childId, parentId]) =>
            Number.isInteger(Number(childId)) &&
            Number(childId) > 0 &&
            Number.isInteger(parentId) &&
            parentId > 0,
        ),
    );
  } catch {
    return {};
  }
}

export function registerGroupedVariantParents(
  childVariantIds: number[],
  parentVariantId: number,
) {
  if (
    typeof window === "undefined" ||
    !Number.isInteger(parentVariantId) ||
    parentVariantId <= 0
  ) {
    return;
  }

  const nextMap = { ...readMap() };

  childVariantIds.forEach((childVariantId) => {
    if (
      Number.isInteger(childVariantId) &&
      childVariantId > 0 &&
      childVariantId !== parentVariantId
    ) {
      nextMap[String(childVariantId)] = parentVariantId;
    }
  });

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextMap));
}

export function getGroupedVariantParentsHeader() {
  const map = readMap();
  return Object.keys(map).length > 0 ? JSON.stringify(map) : null;
}

export function getGroupedVariantParent(childVariantId: number) {
  const parentVariantId = readMap()[String(childVariantId)];

  return Number.isInteger(parentVariantId) && parentVariantId > 0
    ? parentVariantId
    : null;
}
